module.exports = __webpack_public_path__ + "img/408.4d772eed.png";